import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import { toast, } from 'react-toastify';
import { campaignStatus, deleteCampaign, listCampaign, contactandGroupList, campaignMail, detailCampaign } from '../../../Context/api';
import { statusCodes, commonMessage } from '../../../Constants/generalConfig';

const UseCampaign = () => {
    const [campaignList, setCampaignList] = useState([])
    const [allList, setAllList] = useState([])
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const [spinner, setSpinner] = useState(false)
    const navigate = useNavigate()
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const [deleteShow, setDeleteShow] = useState({ open: false, data: '' })
    // const [emailSendModal, setEmailSendModal] = useState({ open: false, data: '' })
    const [emailInputs, setEmailInputs] = useState({
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        template: ''
    })
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            listContactandGroup()
            getCampaign()
        }
    }, [])

    useEffect(() => {
        list()
    }, [page])

    const list = () => {
        setSpinner(true)
        axios.post(listCampaign(), { type: "ADMIN", count: PER_PAGE, page: page, }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCampaignList(resp.data)
                setCount(resp?.data?.totalCount)
                setSpinner(false)
            }
            else {
                setCampaignList([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const campaignDelete = () => {
        setSpinner(true)
        axios.post(deleteCampaign(), { id: deleteShow?.data?._id }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
                setDeleteShow({ open: false, data: '' })
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)
            }
        })
    }
    const statusChange = (item) => {
        setSpinner(true)
        axios.post(campaignStatus(), { id: item._id, isActive: !item.isActive }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                list()
                setSpinner(false)
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }

    // Campaign Email

    const getCampaign = () => {
        axios.post(detailCampaign(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setEmailInputs((pre) => ({ ...pre, template: resp?.data?.data?.template, subject: resp?.data?.data?.subject }))
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const listContactandGroup = () => {
        setSpinner(true)
        axios.post(contactandGroupList(), { type: "ADMIN",count:1000 }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setAllList(resp.data.data)
                setSpinner(false)
            }
            else {
                setAllList([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const mailSend = () => {
        if (!emailInputs?.to?.length) return toast.warn('This message must have at least one recipient')
        const extractEmails = (list) => list?.length ? list.flatMap(item => item.isGroup ? item.contactData.map(cur => cur.email) : item.email) : [];
        const payload = {
            to: extractEmails(emailInputs?.to),
            cc: extractEmails(emailInputs?.cc),
            bcc: extractEmails(emailInputs?.bcc),
            templateId: id,
            type: "ADMIN",
        }
        // console.log(payload, 'payload')
        // return
        setSpinner(true)
        axios.post(campaignMail(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp?.data?.message)
                setSpinner(false)
                setEmailInputs({ to: [], cc: [], bcc: [] })
                setTimeout(() => {
                    navigate(-1)
                }, 1000);
            }
            else {
                setAllList([])
                setSpinner(false)
                toast.error(resp?.data?.message)

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const handleChange = (name, value) => {
        setEmailInputs((prev) => ({ ...prev, [name]: value }));
    };
    // console.log(allList, 'allList')
    // console.log(emailSendModal, 'emailSendModal')
    // console.log(emailInputs, 'emailInputs')
    return {
        setEmailInputs,
        setPage,
        setDeleteShow,
        navigate,
        handleChange,
        mailSend,
        listContactandGroup,
        statusChange,
        campaignDelete,
        emailInputs,
        deleteShow,
        page,
        count,
        PER_PAGE,
        spinner,
        allList,
        campaignList,

    }
}

export default UseCampaign